<template>
  <div class="w-full h-full flex flex-col items-center justify-center p-8">
    <div class="w-2/3 max-w-sm pointer-events-none lottieContainer min-h-24">
      <LottieComponent
        class="scale-150"
        :src="$constants.TRANSACTIONS.LOTTIES.LOADING_ERROR"
      />
    </div>
    <div class="text-center text-2xl font-bold">
      <slot name="errorTitle"> Echec de chargement </slot>
    </div>
    <div class="py-1"></div>
    <div class="text-center text-lg">
      <slot name="errorDescription">
        Une Erreur s'est produite lors du chargement
      </slot>
    </div>
    <div class="py-1"></div>
    <button class="buttonComponent" @click="$emit('refresh')">
      Actualiser
    </button>
  </div>
</template>
